import React, { useCallback, useEffect, useMemo } from 'react';

import { useSelector } from 'react-redux';

import { AccordionPanel } from 'reaxl';

import getFilterTitle from '@/utilities/getFilterTitle';

import srpFiltersDuck from '@/ducks/srp/srpFiltersDuck.js';

import FilterCheckboxes from './FilterCheckboxes';
import FilterPlaceholder from './FilterPlaceholder';

function ExteriorColorFilter({
    onOptionChange = () => { },
    onOptionsClear = () => { },
    handleShowExpansion = () => { },
}) {
    const exteriorColorOptions = useSelector(srpFiltersDuck.selectors.getExteriorColorOptions);
    const exteriorColorValues = useSelector(srpFiltersDuck.selectors.getExteriorColorValues);

    const filterName = 'extColorSimple';

    const isExpanded = useSelector(useCallback((state) => srpFiltersDuck.selectors.isExpansionActive(state, filterName), [filterName]));

    const showFilter = useMemo(
        () => isExpanded && Object.keys(exteriorColorOptions).length !== 0,
        [isExpanded, exteriorColorOptions]
    );

    const title = useMemo(
        () => getFilterTitle('Exterior Color', exteriorColorValues),
        [exteriorColorValues]
    );

    const filterValues = useMemo(() => ({
        extColorSimple: exteriorColorValues,
    }), [exteriorColorValues]);

    const getFilterOptions = useCallback((formattedOptions) => formattedOptions?.map((option) => ({
        ...option,
        label: option.label,
        colorValue: option.value,
    })), []);

    const shouldExpand = useMemo(() => exteriorColorValues.length > 0, [exteriorColorValues.length]);

    // expand the panel if active options inside of it
    useEffect(() => {
        if (shouldExpand) {
            handleShowExpansion(filterName);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldExpand, filterName]);

    const filterCheckboxesProps = useMemo(() => ({
        className: 'visual-checkboxes',
        filter: exteriorColorOptions,
        values: filterValues,
        customFilterOptions: getFilterOptions,
        onOptionChange,
        onOptionsClear,
        withAccordion: false,
    }), [exteriorColorOptions, filterValues, getFilterOptions, onOptionChange, onOptionsClear]);

    return (
        <AccordionPanel
            contentPadding={5}
            eventKey={filterName}
            data-cmp="filterExteriorColors"
            title={title}
        >
            {!showFilter && <FilterPlaceholder uniqueKey={filterName} />}
            {showFilter && <FilterCheckboxes {...filterCheckboxesProps} />}
        </AccordionPanel>
    );
}

ExteriorColorFilter.displayName = 'ExteriorColorFilter';

export default React.memo(ExteriorColorFilter);
